<template>

  <v-layout>
    <div class="col">
      <div class="head-page-title hide-for-small-only">
        <h1 class="main-title">Mijn pas</h1>
      </div>
      <ul id="card-details-tabs" class="tabs">
        <tab-button
          :name="'card'"
          :title="'OV-Chipkaart'"
          :active="activeTab==='card'"
          @click="activateCardTab"
        />
        <tab-button
          :name="'product'"
          :title="'Producten'"
          :active="activeTab==='product'"
          @click="activateProductTab"
        />
        <tab-button
          :name="'trip'"
          :title="'Ritten'"
          :active="activeTab=='trip'"
          @click="activateTripTab"
        />
      </ul>
      <div class="tabs-content">
        <section id="card-panel" :class="{'content': true, 'active': activeTab=='card'}"
                 aria-hidden="false">
          <div class="row">
            <div class="small-12 columns">
              <dl>
                <dt>Kaartnummer</dt>
                <dd>{{ cardDetails.engravedId | engravedId }}</dd>
                <dt>Kaarthouder</dt>
                <dd>{{ combinedAscription || '-' }}</dd>
                <dt>Contract</dt>
                <dd>
                  {{ cardDetails.contractNumber || '-' }}
                </dd>
                <dt>Status kaart:</dt>
                <dd>
                  {{ activeStatusLabel }}
                </dd>
                <dt>Verval datum</dt>
                <dd v-if="cardDetails.expirationDate">{{ cardDetails.expirationDate | dateFormat }}</dd>
                <dd v-else>-</dd>
                <div v-if="cardDetails.replacementCard">
                  <dt>Kaart vervangen door</dt>
                  <dd>
                    <router-link
                      :to="{ name: 'card-details', params: { cardId: cardDetails.replacementCard.id }}">
                      {{ cardDetails.replacementCard.engravedId | engravedId }}
                    </router-link>
                  </dd>
                  <dt>Kaart vervangen per</dt>
                  <dd>{{ cardDetails.replacementCard.replacementCreatedAt | dateFormat }}</dd>
                </div>
              </dl>
            </div>
          </div>
        </section>
        <section id="product-panel" :class="{'content': true, 'active': activeTab=='product'}" aria-hidden="true">&nbsp;
          <tls-products-list @update="loadCardTlsProducts"/>
          <br><br><br><br>
          <ror-products-list @update="loadCardRorProducts"/>
        </section>
        <section id="trip-panel" :class="{'content': true, 'active': activeTab=='trip'}" aria-hidden="true">
          <trip-filter-form @submit="loadCardTrips"/>
          <br clear="all">
          <div v-if="feedback !== null" class="feedback information">
            {{ feedback }}
          </div>
          <trips-list
            v-if="feedback === null"
            :card-details="cardDetails"
            @update="loadCardTrips"
          />
        </section>
      </div>
    </div>
  </v-layout>
</template>
<script>
import VLayout from '../layouts/Default'
import { mapState } from 'vuex'
import TabButton from '../components/tabs/TabButton'
import TlsProductsList from '../components/tlsProducts/TlsProductsList'
import RorProductsList from '../components/rorProducts/RorProductsList'
import TripsList from '../components/trips/TripList'
import TripFilterForm from '../components/forms/TripFilterForm'
import SelectInput from '../components/forms/fields/SelectInput'
import { loadCardDetails } from '../routes'
import showAlertErrorHandler from '../mixins/show-alert-error-handler'

export default {
  name: 'CardDetailsPage',
  components: {
    TabButton,
    VLayout,
    TlsProductsList,
    RorProductsList,
    TripsList,
    TripFilterForm,
    SelectInput
  },
  mixins: [showAlertErrorHandler],
  data: () => ({
    activeTab: 'card',
    searched: false
  }),
  computed: {
    ...mapState({
      cardDetails: state => state.card.cardDetails
    }),
    combinedAscription: function () {
      return [this.cardDetails.ascription, this.cardDetails.ascription1, this.cardDetails.ascription2].filter(
        part => part !== null && part.length > 0
      ).join(' ')
    },
    activeStatusLabel: function () {
      const label = this.cardDetails.activeCommercial ? 'active' : 'inactive'
      return this.$t(`card.activeCommercialStatus.${label}`)
    },
    feedback: function () {
      if (!this.searched) {
        return 'Geef minimaal één filter waarde op'
      }
      return null
    }
  },
  methods: {
    activateCardTab: function () {
      this.activeTab = 'card'
    },
    activateProductTab: function () {
      this.activeTab = 'product'
      this.loadCardProducts()
    },
    loadCardProducts: function () {
      this.loadCardTlsProducts()
      this.loadCardRorProducts()
    },
    loadCardTlsProducts: async function () {
      if (this.cardDetails) {
        try {
          await this.$store.dispatch('tlsProduct/loadProducts', this.cardDetails.cardId)
        } catch (error) {
          this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
        }
      }
    },
    loadCardRorProducts: async function () {
      if (this.cardDetails) {
        try {
          await this.$store.dispatch('rorProduct/loadProducts', this.cardDetails.cardId)
        } catch (error) {
          this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
        }
      }
    },
    loadCardTrips: async function () {
      if (this.cardDetails) {
        try {
          this.searched = true
          await this.$store.dispatch('trip/loadTrips', this.cardDetails.cardId)
        } catch (error) {
          this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
        }
      }
    },
    loadCardTripFilterMonths: async function () {
      if (this.cardDetails) {
        try {
          await this.$store.dispatch('trip/loadFilterMonths', this.cardDetails.cardId)
        } catch (error) {
          this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
        }
      }
    },
    activateTripTab: function () {
      this.searched = false
      this.activeTab = 'trip'
      this.loadCardTripFilterMonths()
    }
  },
  beforeRouteUpdate (to, from, next) {
    // When a route is requested which will lead to the same component, Vue will update the url but won't reload
    // the component. Therefore the data will need to be loaded manually.
    if (to.name === this.$route.name && to.params['cardId'] !== this.$route.params['cardId']) {
      loadCardDetails(this.$store, to.params['cardId'], to, from, next)
    }
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CardDetailsPage.vue